import { render } from "./QpRules.vue?vue&type=template&id=ac8779e6&ts=true"
import script from "./QpRules.vue?vue&type=script&lang=ts"
export * from "./QpRules.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__